var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsManagementPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_919_402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.23747 15.2031H3.66733C3.41742 15.2031 3.21484 15.4057 3.21484 15.6556C3.21484 15.9055 3.41742 16.1081 3.66733 16.1081H8.23747C8.48738 16.1081 8.68996 15.9055 8.68996 15.6556C8.68996 15.4057 8.48738 15.2031 8.23747 15.2031Z",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0702 15.2031H10.5001C10.2502 15.2031 10.0476 15.4057 10.0476 15.6556C10.0476 15.9055 10.2502 16.1081 10.5001 16.1081H15.0702C15.3201 16.1081 15.5227 15.9055 15.5227 15.6556C15.5227 15.4057 15.3201 15.2031 15.0702 15.2031Z",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.07 3.89062H3.66733C3.41742 3.89062 3.21484 4.0932 3.21484 4.34311C3.21484 4.59302 3.41742 4.7956 3.66733 4.7956H15.07C15.3199 4.7956 15.5225 4.59302 15.5225 4.34311C15.5225 4.0932 15.3199 3.89062 15.07 3.89062Z",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0702 6.15234H10.5001C10.2502 6.15234 10.0476 6.35492 10.0476 6.60483C10.0476 6.85474 10.2502 7.05732 10.5001 7.05732H15.0702C15.3201 7.05732 15.5227 6.85474 15.5227 6.60483C15.5227 6.35492 15.3201 6.15234 15.0702 6.15234Z",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0702 8.41602H10.5001C10.2502 8.41602 10.0476 8.61859 10.0476 8.8685C10.0476 9.11841 10.2502 9.32099 10.5001 9.32099H15.0702C15.3201 9.32099 15.5227 9.11841 15.5227 8.8685C15.5227 8.61859 15.3201 8.41602 15.0702 8.41602Z",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0702 10.6777H10.5001C10.2502 10.6777 10.0476 10.8803 10.0476 11.1302C10.0476 11.3801 10.2502 11.5827 10.5001 11.5827H15.0702C15.3201 11.5827 15.5227 11.3801 15.5227 11.1302C15.5227 10.8803 15.3201 10.6777 15.0702 10.6777Z",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0702 12.9414H10.5001C10.2502 12.9414 10.0476 13.144 10.0476 13.3939C10.0476 13.6438 10.2502 13.8464 10.5001 13.8464H15.0702C15.3201 13.8464 15.5227 13.6438 15.5227 13.3939C15.5227 13.144 15.3201 12.9414 15.0702 12.9414Z",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.23747 12.9414H3.66733C3.41742 12.9414 3.21484 13.144 3.21484 13.3939C3.21484 13.6438 3.41742 13.8464 3.66733 13.8464H8.23747C8.48738 13.8464 8.68996 13.6438 8.68996 13.3939C8.68996 13.144 8.48738 12.9414 8.23747 12.9414Z",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.23747 6.15234H3.66733C3.41742 6.15234 3.21484 6.35492 3.21484 6.60483V11.175C3.21484 11.4249 3.41742 11.6275 3.66733 11.6275H8.23747C8.48738 11.6275 8.68996 11.4249 8.68996 11.175V6.60483C8.68996 6.35492 8.48738 6.15234 8.23747 6.15234ZM7.78498 10.7225H4.11982V7.05732H7.78498V10.7225Z",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.595 3.43822H18.2376V2.08076C18.2376 1.58175 17.8316 1.17578 17.3326 1.17578H1.40498C0.905973 1.17578 0.5 1.58175 0.5 2.08076V16.5604C0.5 17.8079 1.51493 18.8228 2.76244 18.8228H18.2376C19.4851 18.8228 20.5 17.8079 20.5 16.5604V4.3432C20.5 3.8442 20.094 3.43822 19.595 3.43822ZM19.595 16.5604C19.595 17.3089 18.9861 17.9179 18.2376 17.9179H2.76244C2.01394 17.9179 1.40498 17.3089 1.40498 16.5604V2.08076H17.3326V15.8817C17.3326 16.5054 17.84 17.0129 18.4638 17.0129C18.7137 17.0129 18.9163 16.8103 18.9163 16.5604C18.9163 16.3105 18.7137 16.1079 18.4638 16.1079C18.3391 16.1079 18.2376 16.0064 18.2376 15.8817V4.3432H19.595V16.5604Z",
    fill: "#5E35B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_919_402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsManagementPurple);
export default __webpack_public_path__ + "static/media/NewsManagementPurple.c6d26772c72f13177d6a490882b0f39a.svg";
export { ForwardRef as ReactComponent };